import axios from 'axios';
import { ServerStatus, IGameserverSettingsLinks, IServerQueryResponse } from '../../interface';
import { Notification } from '../../../notification/notfication';
import { initModal } from '../../../modal/modal';

const INSTALLING_SELECTOR: string = ".installing";
const BASE_SELECTOR: string = "[data-gameserver]";
const RESTART_BUTTON_SELECTOR: string = "[data-server-restart]";
const START_BUTTON_SELECTOR: string = "[data-server-start]";
const STOP_BUTTON_SELECTOR: string = "[data-server-stop]";
const DELETE_BUTTON_SELECTOR: string = "[data-server-delete]";
const DELETE_BUTTON_SELECTOR__CONFIRM: string = "[data-server-delete-confirm]";
const DELETE_BUTTON_SELECTOR__CANCEL: string = "[data-server-delete-cancel]";
const STATUS_SELECTOR: string = ".gameserver__status";
const QUICKMENU_SELECTOR: string = ".gameserver__quickmenu";
const templateStatus = require('./view/status.handlebars');
const templateSettings = require('./view/settings.handlebars');
const templateMeta = require('./view/meta.handlebars');

export class GameserverUI {
  private ipAddress: string = this.$base.find('.gameserver__ip span:first-of-type').text();

  constructor(private $base: JQuery) {}

  public showInstalling(details) {
    const installing = this.$base.find(INSTALLING_SELECTOR);
    if (typeof details !== 'undefined' && details) {
      installing.addClass('is-visible');
      installing.find('.installing__progress span').css('width', details.percentage + '%');
    } else {
      installing.removeClass('is-visible');
    }
  }

/**
 * Loading
 * The Gameserver is doing something
 * Add a class to show a loading
 */
  public loading(state: boolean) : void {
    if (state) {
      this.$base.addClass('gameserver--loading');
    } else {
      this.$base.removeClass('gameserver--loading');
    }
  }

  /**
  * onRestart
  * @param beforeRestart - method called before start restarting
  * @param afterRestart - method called after restarting
  * @param onError - method called on error
  */
  public onRestart(beforeRestart: () => {}, afterRestart: () => {}, onError: (error) => {}) : void {
    const self = this;
    this.$base.find(RESTART_BUTTON_SELECTOR).on('click', function(e) {
      beforeRestart();
      e.preventDefault();
      const url: string = $(this).attr('href');
      axios.get(url).then(() => {
        afterRestart();
        new Notification('success', 'Done', 'Your server will restart now');
      }).catch((error) => {
        new Notification('success', 'Done', error.data.message);
        onError(error);
      });
    });
  }

  /**
  * onRestart
  * @param beforeRestart - method called before start restarting
  * @param afterRestart - method called after restarting
  * @param onError - method called on error
  */
  public onStart(beforeRestart: () => {}, afterRestart: () => {}, onError: (error) => {}): void {
    const self = this;
    this.$base.find(START_BUTTON_SELECTOR).on('click', function (e) {
      beforeRestart();
      e.preventDefault();
      const url: string = $(this).attr('href');
      axios.get(url).then(() => {
        new Notification('success', 'Done', 'Your server will start now');
        afterRestart();
      }).catch((error) => {
        onError(error);
      });
    });
  }

  /**
  * onStop
  * @param beforeStop - method called before start restarting
  * @param afterStop - method called after restarting
  * @param onError - method called on error
  */
  public onStop(beforeStop: () => {}, afterStop: () => {}, onError: (error) => {}): void {
    const self = this;
    this.$base.find(STOP_BUTTON_SELECTOR).on('click', function (e) {
      beforeStop();
      e.preventDefault();
      const url: string = $(this).attr('href');
      axios.get(url).then(() => {
        new Notification('success', 'Done', 'Your server will stop now');
        afterStop();
      }).catch((error) => {
        onError(error);
      });
    });
  }

  /**
   * onDelete
   */

   public onDelete(beforeDelete: () => {}, onConfirm: () => {}, onCancel: () => {}) {
     this.$base.find(DELETE_BUTTON_SELECTOR).on('click', (e) => {
        e.preventDefault();
        this.$base.addClass('gameserver--delete');
        return false;
     });

     this.$base.find(DELETE_BUTTON_SELECTOR__CONFIRM).on('click', () => {
       beforeDelete();
       onConfirm();
     });

     this.$base.find(DELETE_BUTTON_SELECTOR__CANCEL).on('click', () => {
       onCancel();
     });
   }

  public destroyServer(afterDelete: () => {}) {
    this.$base.removeClass('gameserver--delete');
    const url: string = this.$base.find(DELETE_BUTTON_SELECTOR).attr('href');
    const $list = this.$base.closest('.gameserverlist');
    // POST with the Serverlib header so the backend answers with the JSON
    // { result, message } contract (GamecloudsController::delete's
    // $isServerLibRequest branch) instead of an HTML redirect. The delete can be
    // rejected with a reason (e.g. TV-1651: a paused subscription rejects the
    // delete) — only tear the card down on success; on rejection surface the
    // message instead of silently removing the card (which looked to QA like the
    // delete had silently reverted).
    axios.post(url, {}, { headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-Requested-By-Module': 'G-Portal Serverlib',
    }}).then((response) => {
      if (response.data && response.data.result) {
        this.$base.remove();
        afterDelete();
        // TR-5049: deliberately no window.location.reload() here — reloading the
        // dashboard after every delete made it impossible to remove several servers
        // in a row. The reload only existed to reveal the "Add Server" tile on
        // Chargebee clouds once the last server is gone, so do that in the DOM.
        if ($list.length && $list.find('[data-gameserver]').length === 0) {
          $list.find('.gameserver--add').show();
        }
      } else {
        afterDelete();
        new Notification('danger', 'Error', (response.data && response.data.message) || 'Your server could not be deleted');
      }
    }).catch((error) => {
      afterDelete();
      new Notification('danger', 'Error', (error && error.response && error.response.data && error.response.data.message) || 'Your server could not be deleted');
    });
   }

   /**
    * Render Meta
    */

   public renderMeta(data: IServerQueryResponse, destroyTimeOut: () => void) {
     if (data.queried) {
       data.ipAddress = this.ipAddress;
       this.$base.find('.gameserver__info').html(templateMeta({data}));

       // Atlas fixes
       $('[data-atlas-port]').text(':' + data.port);
       $('[data-atlas-slots]').text(`${data.currentPlayers}/${data.maxPlayers}`);
     } else {
       destroyTimeOut();
     }
   }

  /**
   * Render Node Meta
   */

  public renderNodeMeta(data: IServerQueryResponse, serverId, destroyTimeOut: () => void) {
    if (data.queried) {
      //$('[data-server-name-'+serverId+']').text(data.name);
      $('[data-atlas-slots-'+serverId+']').text(`${data.currentPlayers}/${data.maxPlayers}`);
    } else {
      destroyTimeOut();
    }
  }

  /**
   * Render
   * rerender some UI Elements
   * @param state - number of the current state (see also gamecloud/interface.ts)
   * @param links
   */
  public render(state: number, links: IGameserverSettingsLinks): void {
    let data;

    const menuOffline = {
      settings: links.settings,
      delete: links.delete,
      options: {
        start: {
          type: 'start',
          tooltip: 'Start',
          icon: 'play-circle',
          link: links.start
        },
      },
      showSettings: this.$base.data('server-show-settings'),
    };

    const menuOnline = {
      settings: links.settings,
      delete: links.delete,
      options: {
        restart: links.restart != '' ? {
          type: 'restart',
          tooltip: 'Restart',
          icon: 'undo',
          link: links.restart,
        } : undefined,
        stop: {
          tooltip: 'Stop',
          type: 'stop',
          icon: 'power-off',
          link: links.stop,
        },
      },
      showSettings: this.$base.data('server-show-settings'),
    };

    const menuSuspended = {
      settings: links.settings,
      delete: links.delete,
      showDelete: true,
      options: {},
      showSettings: false,
    };

    switch (state) {
      case ServerStatus.Install:
        this.loading(true);
        data = { state: 'Installing', menu: {} };
        break;
      case ServerStatus.Maintenance:
        this.loading(true);
        data = { state: 'Maintenance', menu: {} };
        break;
      case ServerStatus.PreInstall:
        this.loading(true);
        data = { state: 'Installing', menu: {} };
        break;
      case ServerStatus.Removing:
        this.loading(true);
        data = { state: 'Removing', menu: {} };
        break;
      case ServerStatus.Starting:
        this.loading(true);
        data = { state: 'Starting', menu: {} };
        break;
      case ServerStatus.Stopped:
        this.loading(false);
        data = { state: 'Stopped', menu: menuOffline };
        break;
      case ServerStatus.Stopping:
        this.loading(true);
        data = { state: 'Stopping', menu: {} };
        break;
      case ServerStatus.Suspended:
        this.loading(false);
        data = { state: 'Suspended', menu: menuSuspended};
        break;
      case ServerStatus.Unknown:
        this.loading(false);
        data = { state: 'Unkown', menu: menuOffline };
        break;
      case ServerStatus.Updating:
        this.loading(true);
        data = { state: 'Updating', menu: {} };
        break;
      case ServerStatus.Loading:
        this.loading(true);
        data = { state: 'Loading', menu: {} };
        break;
      case ServerStatus.Running:
        this.loading(false);
        data = { state: 'Running', menu: menuOnline };
        break;
      default:
        this.loading(false);
        data = { state: 'Unkown', menu: menuOffline };
    }

    if (this.isDeacticated()) {
      data.menu = menuSuspended;
    }

    this.$base.find(STATUS_SELECTOR).html(templateStatus(data));
    this.$base.find(QUICKMENU_SELECTOR).html(templateSettings({...data, orderId: this.getOrderId(), serviceId: this.getServiceId()}));
    window.setTimeout(() => {
      initModal();
    }, 500);
  }

  public isDeacticated() : boolean {
    return !!this.$base.data('deactivated');
  }

  /**
   * Read the server id from a data-attribut
   * @return string
   */
  public getServerId(): number {
    return this.$base.data('server-id');
  }

  /**
   * Read the service id from a data-attribut
   * @return string
   */
  public getServiceId(): number {
    return this.$base.data('service-id');
  }

  /**
   * Read the service id from a data-attribut
   * @return string
   */
  public getOrderId(): number {
    return this.$base.data('order-id');
  }

  /**
   * Read the service id from a data-attribut
   * @return string
   */
  public getLinks(): IGameserverSettingsLinks {
    return this.$base.data('server-links');
  }

  public getName() : string {
    return this.$base.find('.gameserver__title').text();
  }

  public getIP() : string {
    return this.$base.find('.gameserver__ip').text();
  }

  /**
   * Reset UI states
   */
  public reset() {
    this.$base.removeAttr('class').addClass('gameserver');
  }

}

export function createGameserverUI(): GameserverUI[] {
  const gameserverUI: GameserverUI[] = [];
  const $base = $(BASE_SELECTOR);

  $base.each((index, el) => {
    gameserverUI.push(new GameserverUI($(el)));
  });

  return gameserverUI;
}
